import { createFileRoute } from '@tanstack/react-router';

import { ConfigurationManagerLayout } from '~/features/configuration/components/configuration-manager-layout';

/**
 * `/configuration/manager` — Configuration Manager layout that wraps the
 * Parameters and Audit Trail tabs with the page header, the pill tab toggle,
 * and the Platform dropdown. Experiment Configuration sits OUTSIDE this
 * layout because it has its own chrome and doesn't use the Platform selector.
 * Children resolve to `/configuration/manager/parameters` and
 * `/configuration/manager/audit-trail`; `/configuration/manager` itself
 * redirects to the Parameters tab via `manager/index.tsx`.
 */
export const Route = createFileRoute('/_authenticated/_tenant/configuration/manager')({
  component: ConfigurationManagerLayout,
});
